/**
 * Assistant Search Service
 * Fetches lightweight normalized content-search results for the navigation assistant.
 */
import api from './apiClient';

/**
 * Search assistant content groups by a free-text query.
 * @param {string} query - User-entered search query
 * @param {Object} [params={}] - Optional query params
 * @param {number} [params.groupSize=4] - Maximum results per returned group
 * @param {Object} [options={}] - Request options
 * @returns {Promise<Object>} Grouped assistant search results
 */
export const searchAssistantContent = async (query, params = {}, options = {}) => {
  return api.get('/search/content', {
    q: query,
    groupSize: params.groupSize ?? 4,
  }, options);
};

const assistantSearchService = {
  searchAssistantContent,
};

export default assistantSearchService;